import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import SwipeableViews from "react-swipeable-views";

import axiosConfig from "../../axiosConfig";
import MaterialUIPickers from "../Datepicker/Datepicker";
import {
  Card,
  CardHeader,
  CardFooter,
  CardBody,
} from "../../shared/Card/Index";
import styles from "../../shared/dashboardStyle";

import { makeStyles, useTheme } from "@material-ui/core/styles";
import { CardContent } from "@material-ui/core";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";

import { MyResponsiveBar } from "../Charts/Barchart/barChart";
import AverageTimes from "./AverageTimes";
import AverageTimesPerUser from "./AverageTimesPerUser";
import CountPerUser from "./CountPerUser";

import "../AlarmStats/VerticalTabForStatsCharts.css";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <div>{children}</div>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}
const useStyles2 = makeStyles(styles);

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "white",
    width: "100%",
    margin: "auto",
    marginTop: "2.5%",
  },
  tabs: {
    width: "100%",
    backgroundColor: "white",
  },
}));

export const UserStats = () => {
  const classes = useStyles();
  const classe2 = useStyles2();
  const theme = useTheme();
  const [value, setValue] = useState(0);
  const [avgTimes, setAvgTimes] = useState("");
  const [avgTimesPerUser, setAvgTimesPerUser] = useState("");
  const [countOfAlarmsPerUser, setCountOfAlarmsPerUser] = useState("");
  let currentDate = new Date();
  currentDate.setDate(currentDate.getDate() - 14);
  
  const [dateFrom, setDateFrom] = useState(currentDate.toISOString().slice(0, 10));
  const [dateTo, setDateTo] = useState(new Date().toISOString().slice(0, 10));

  useEffect(() => {
    datesSubmit();
  }, []);

  const fetchAvgTimes = () => {
    axiosConfig
      .get(`/UserStatistics/AverageResponseTime?dateFrom=${dateFrom}&dateTo=${dateTo}`)
      .then((res) => {
        setAvgTimes(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const fetchAvgTimesPerUser = () => {
    axiosConfig
      .get(
        `/UserStatistics/AverageResponseTimePerUser?dateFrom=${dateFrom}&dateTo=${dateTo}`)
      .then((res) => {
        setAvgTimesPerUser(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const fetchCountOfAlarmsPerUser = () => {
    axiosConfig
      .get(
        `/UserStatistics/AlarmsOfUserCount?dateFrom=${dateFrom}&dateTo=${dateTo}`)
      .then((res) => {
        setCountOfAlarmsPerUser(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleDateChangeFinal = (date) => {
    if (date) { 
      setDateTo(date.toISOString().slice(0, 10))
      let previousDate = date.setDate(date.getDate() - 14)  
      setDateFrom((new Date(previousDate)).toISOString().slice(0, 10))
    }
  }

  const datesSubmit = (e) => {
    fetchAvgTimes();
    fetchAvgTimesPerUser();
    fetchCountOfAlarmsPerUser();
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleChangeIndex = (index) => {
    setValue(index);
  };

  return (
    <div className={classes.root}>
      <Card>
        <CardHeader color="warning">
          <h1 className={classe2.cardTitleWhite}>Στατιστικά Χειριστών</h1>
        </CardHeader>
        <CardBody>
          <MaterialUIPickers
            initialDate={dateFrom}
            finalDate={dateTo}
            handleDateChangeFinal={handleDateChangeFinal}
            datesSubmit={datesSubmit}
          />
        </CardBody>
        <CardFooter>
          <Tabs
            className={classes.tabs}
            value={value}
            onChange={handleChange}
            indicatorColor="primary"
            textColor="primary"
            variant="fullWidth"
            aria-label="full width tabs example"
          >
            <Tab label="ΜΕΣΟΣ ΧΡΟΝΟΣ ΑΠΟΚΡΙΣΗΣ ΣΥΝΟΛΙΚΑ" {...a11yProps(0)} />
            <Tab
              label="ΜΕΣΟΣ ΧΡΟΝΟΣ ΑΠΟΚΡΙΣΗΣ ΑΝΑ ΧΕΙΡΙΣΤΗ"
              {...a11yProps(1)}
            />
            <Tab label="ΠΛΗΘΟΣ ΕΙΔΟΠΟΙΗΣΕΩΝ ΑΝΑ ΧΕΙΡΙΣΤΗ" {...a11yProps(2)} />
          </Tabs>
        </CardFooter>
      </Card>
      <SwipeableViews
        axis={theme.direction === "rtl" ? "x-reverse" : "x"}
        index={value}
        onChangeIndex={handleChangeIndex}
      >
        {/* Λίστα μέσου χρόνου απόκρισης συνολικά */}
        <TabPanel value={value} index={0} dir={theme.direction}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={12} md={12}>
              <AverageTimes data={avgTimes} />
            </Grid>
          </Grid>
        </TabPanel>

        {/* Λίστα μέσου χρόνου απόκρισης ανά χειριστή */}
        <TabPanel value={value} index={1} dir={theme.direction}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={12} md={12}>
              <Card>
                <CardContent>
                  <Box height={300} position="relative">
                    <MyResponsiveBar
                      data={avgTimesPerUser}
                      origin="AvgTimePerUser"
                    />
                  </Box>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <AverageTimesPerUser data={avgTimesPerUser} />
            </Grid>
          </Grid>
        </TabPanel>

        {/* Λίστα πλήθους ειδοποιήσεων ανά χειριστή */}
        <TabPanel value={value} index={2} dir={theme.direction}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={12} md={12}>
              <Card>
                <CardContent>
                  <Box height={300} position="relative">
                    <MyResponsiveBar
                      data={countOfAlarmsPerUser}
                      origin="Counts"
                    />
                  </Box>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <CountPerUser data={countOfAlarmsPerUser} />
            </Grid>
          </Grid>
        </TabPanel>
      </SwipeableViews>
    </div>
  );
};
